import React from 'react';

const WEIGHTS = {
	extralight: 'font-extralight',
	light: 'font-light',
	regular: 'font-normal',
	medium: 'font-medium',
	semibold: 'font-semibold',
	bold: 'font-bold',
};

const AppText = ({ children, weight = 'regular', as: Component = 'p', className = '', ...props }) => {
	const weightClass = WEIGHTS[weight] || WEIGHTS.regular;
	const classes = `font-poppins ${weightClass} ${className}`.trim();
	return (
		<Component className={classes} {...props}>
		{children}
		</Component>
	);
};

export default AppText;
